module.exports = __webpack_public_path__ + "img/4082495.png";